import React, { useState } from "react";
import { db, storage } from "./firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import heic2any from "heic2any";

function CostumeForm() {
  const [name, setName] = useState("");
  const [photo, setPhoto] = useState(null);
  const [category, setCategory] = useState("Single");
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    let convertedFile = file;

    // Convert HEIC to JPEG if needed
    if (file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic")) {
      try {
        const blob = await heic2any({ blob: file, toType: "image/jpeg" });
        convertedFile = new File(
          [blob],
          file.name.replace(/\.heic$/i, ".jpg"),
          { type: "image/jpeg" }
        );
      } catch (err) {
        console.error("HEIC conversion error:", err);
        alert("Failed to convert HEIC file.");
        return;
      }
    }

    setPhoto(convertedFile);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!name || !photo) {
      alert("Please provide a name and photo.");
      return;
    }

    setLoading(true);
    try {
      // Upload file to Firebase Storage
      const storageRef = ref(storage, `costumes/${photo.name}-${Date.now()}`);
      await uploadBytes(storageRef, photo);
      const photoURL = await getDownloadURL(storageRef);

      // Add submission to Firestore
      await addDoc(collection(db, "costumes"), {
        name,
        category,
        photoURL,
        votes: {
          bestOverall: 0,
          scariest: 0,
          sexiest: 0,
          cutest: 0,
          bestCouples: 0,
          funniest: 0,
          bestDIY: 0
        },
        timestamp: Timestamp.now()
      });

      // Reset form
      setName("");
      setPhoto(null);
      setCategory("Single");
      alert("Costume submitted!");
    } catch (err) {
      console.error("Upload error:", err);
      alert("Failed to submit costume.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>Name: </label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>

      <div>
        <label>Category: </label>
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          <option value="Single">Single</option>
          <option value="Couple">Couple</option>
        </select>
      </div>

      <div>
        <label>Photo: </label>
        <input type="file" accept="image/*" onChange={handleFileChange} required />
      </div>

      <button type="submit" disabled={loading}>
        {loading ? "Submitting..." : "Submit"}
      </button>
    </form>
  );
}

export default CostumeForm;
